import Super from './-resources';
import classic from 'ember-classic-decorator';

@classic
export default class SiteBillingSuperbills extends Super {
  thisType = 'superbill';
}
